<template>
  <button type="submit"  class="ubox-button ubox-button-primary"  @click="handleClick">
    <slot>
      <span>这是一个按钮</span>
    </slot>
  </button>
</template>

<script>
export default {
  name: "PrimaryButton",
  methods:{
    handleClick(){
      this.$emit('click')
    }
  }
}
</script>

<style>

.ubox-button{
  display: flex;
  height: 46px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border: none;
  cursor: pointer;
}
.ubox-button-primary{
  background: var(--primary-color);
  color: #FFF;
}
</style>
